const runMonth = $('#runMonth').val();
export default function() {
    createBrev12Grid($('#projectClosureGrid'));
    createBrev12SubmittedGrid($('#projectClosureSubmissionGrid'));
    createBrev12FormGrid($('#brev12FormGrid'));
}

const createBrev12Grid = $projectClosureGrid => {
    if ($projectClosureGrid.length) {
        $projectClosureGrid.kendoGrid({
            columns: [
                {
                    field: 'Contract',
                    title: 'Contract',
                    template(dataItem) {
                        return `${dataItem.Contract} - ${dataItem.ContractDescription}`;
                    },
                    headerAttributes: { style: 'white-space: normal' },
                    filterable: true,
                    width: 220
                },
                {
                    field: 'RevisedEqBilled',
                    title: 'Revised Equals Billed',
                    template(dataItem) {
                        return passFailTemplate(dataItem.RevisedEqBilled);
                    },
                    headerAttributes: { style: 'white-space: normal' },
                    filterable: false,
                    width: 102
                },
                {
                    field: 'BilledEqReceived',
                    title: 'Billed Equals Received',
                    template(dataItem) {
                        return passFailTemplate(dataItem.BilledEqReceived);
                    },
                    headerAttributes: { style: 'white-space: normal' },
                    filterable: false,
                    width: 102
                },
                {
                    field: 'EstimatedEqProjected',
                    title: 'Job to Date Equals Projected',
                    template(dataItem) {
                        return passFailTemplate(dataItem.EstimatedEqProjected);
                    },
                    headerAttributes: { style: 'white-space: normal' },
                    filterable: false,
                    width: 102
                },
                {
                    field: 'ZeroUnapprovedAp',
                    title: 'No Unapproved APs',
                    template(dataItem) {
                        return passFailTemplate(dataItem.ZeroUnapprovedAp);
                    },
                    headerAttributes: { style: 'white-space: normal' },
                    filterable: false,
                    width: 102
                },
                {
                    field: 'ZeroCommittedCosts',
                    title: 'No Committed Costs',
                    template(dataItem) {
                        return passFailTemplate(dataItem.ZeroCommittedCosts);
                    },
                    headerAttributes: { style: 'white-space: normal' },
                    filterable: false,
                    width: 102
                },
                {
                    field: 'ZeroPeriodCost',
                    title: 'No Costs This Period',
                    template(dataItem) {
                        return passFailTemplate(dataItem.ZeroPeriodCost);
                    },
                    headerAttributes: { style: 'white-space: normal' },
                    filterable: false,
                    width: 102
                },
                {
                    field: 'ZeroOverUnderBilled',
                    title: 'No Over/Under Billed',
                    template(dataItem) {
                        return passFailTemplate(dataItem.ZeroOverUnderBilled);
                    },
                    headerAttributes: { style: 'white-space: normal' },
                    filterable: false,
                    width: 102
                },
                {
                    field: 'ReadyToClose',
                    title: '<temp>Status</temp>',
                    template(dataItem) {
                        return readyToCloseTemplate(dataItem);
                    },
                    headerAttributes: { style: 'white-space: normal' },
                    filterable: false,
                    width: 146,
                    sortable: false
                }
            ],
            dataSource: {
                transport: {
                    read: {
                        url: `/Compliance/Sox/ProjectClosure?runMonth=${runMonth}`,
                        type: 'POST',
                        dataType: 'json'
                    }
                },
                pageSize: 13
            },
            resizable: false,
            mobile: false,
            scrollable: true,
            sortable: {
                mode: 'multiple'
            },
            filterable: true,
            dataBound(e) {
                $('.spinner#loading').hide();
                $('.gridContainer').show();
                setUpGrid();
            },
            pageable: {
                alwaysVisible: false,
                pageSizes: true,
                buttonCount: 13
            }
        });
    }
};

const passFailTemplate = passed => {
    return `<div class="t-center ${passed && ''}" data-passed="${passed}"><span class='k-icon k-icon-md ${
        passed ? 'k-i-check' : 'k-i-minus'
    }'></span></div>`;
};
const readyToCloseTemplate = dataItem => {
    const passed = dataItem.ReadyToClose;
    if (dataItem.RevisedContract <= 100000) {
        return `<span class="t-muted t-italic" data-ready-to-close="${passed}">Form Not Required</span>`;
    }
    if (!passed) {
        return '<span class="t-muted t-italic">Not Ready To Close</span>';
    }
    if (dataItem.ApprovedBy) {
        return `<a href="/Compliance/Sox/Brev12Form?company=${dataItem.Company}&contract=${dataItem.Contract}&runMonth=${runMonth}" class="k-button k-small k-dark" data-ready-to-close="${passed}"><span class=''>Review Form</span></a>`;
    }
    return `<a href="/Compliance/Sox/Brev12Form?company=${dataItem.Company}&contract=${dataItem.Contract}&runMonth=${runMonth}" class="k-button k-dark k-small" data-ready-to-close="${passed}"><span class=''>Open Form</span></a>`;
};

const setCellColor = () => {
    const $criteriaCells = $('[data-passed]');

    if ($criteriaCells.length) {
        $.each($criteriaCells, (index, ele) => {
            const $cell = $(ele).parent();
            const passed = $(ele).data('passed');
            $cell.addClass('grid-cell grid-cell--status');
            $cell.addClass(passed ? '--success' : '--default');
        });
    }
};

const setRowColor = () => {
    const $readyToClose = $('[data-ready-to-close]');
    if ($readyToClose.length) {
        $.each($readyToClose, function(index, ele) {
            if ($(ele).data('ready-to-close')) {
                $(ele)
                    .closest('tr')
                    .find('td')
                    .addClass('grid-cell grid-cell--status --success');
            }
        });
    }
};

const createDropDownFilter = () => {
    const $readyToCloseFilter = $('[data-field="ReadyToClose"] temp');

    if (!$readyToCloseFilter.data('kendoDropDownList')) {
        $readyToCloseFilter.html('');
        $readyToCloseFilter.kendoDropDownList({
            dataSource: new kendo.data.DataSource({
                data: [
                    {
                        text: 'All',
                        value: JSON.stringify({})
                    },
                    {
                        text: 'Ready To Close',
                        value: JSON.stringify({ field: 'ReadyToClose', operator: 'eq', value: true })
                    },
                    {
                        text: 'Not Ready',
                        value: JSON.stringify({ field: 'ReadyToClose', operator: 'eq', value: false })
                    }
                ]
            }),
            dataTextField: 'text',
            dataValueField: 'value'
        });
        $readyToCloseFilter.change(function() {
            $('#projectClosureGrid')
                .data('kendoGrid')
                .dataSource.filter(JSON.parse(this.value));
        });

        $readyToCloseFilter.data('kendoDropDownList').select(1);
        $readyToCloseFilter.change();
    }
};

const setUpGrid = () => {
    setCellColor();
    setRowColor();

    createDropDownFilter();
};

const createBrev12SubmittedGrid = $projectClosureGrid => {
    if ($projectClosureGrid.length) {
        const runMonth = $('#runMonth')
            .val()
            .replace('/', '/1/');
        $projectClosureGrid.kendoGrid({
            columns: [
                {
                    field: 'contract',
                    title: 'Contract',
                    headerAttributes: { style: 'white-space: normal' },
                    filterable: false,
                    width: 356
                },
                {
                    field: 'FullName',
                    title: 'Approved By',
                    headerAttributes: { style: 'white-space: normal' },
                    filterable: false,
                    width: 300
                },
                {
                    field: 'approvalDate',
                    title: 'Approval Date',
                    template(dataItem) {
                        return new Date(dataItem.approvalDate).toLocaleDateString();
                    },
                    headerAttributes: { style: 'white-space: normal' },
                    filterable: false,
                    width: 278
                },
                {
                    field: '',
                    title: 'Form Link',
                    template(dataItem) {
                        return `<a href="/Forms/ProjectReview/ProjectClosure?projectInfo=${dataItem.contract}&Company=${dataItem.company}" class="k-button k-dark k-small"><span class=''>Open Form</span></a>`;
                    },
                    headerAttributes: { style: 'white-space: normal' },
                    width: 146,
                    sortable: false
                }
            ],
            dataSource: {
                transport: {
                    read: {
                        url: `/Compliance/Sox/SubmittedProjectClosure?runMonth=${runMonth}`,
                        type: 'POST',
                        dataType: 'json'
                    }
                },
                pageSize: 13
            },
            resizable: false,
            mobile: false,
            scrollable: true,
            sortable: {
                mode: 'multiple'
            },
            dataBound(e) {
                $('.spinner#loading').hide();
                $('.gridContainer').show();
            },
            pageable: {
                alwaysVisible: false,
                pageSizes: true,
                buttonCount: 13
            }
        });
    }
};

const createBrev12FormGrid = $brev12FormGrid => {
    $brev12FormGrid.kendoGrid({
        scrollable: false
    });
};
